import { logError, logInfo } from '../utils/logger';
import { api } from './api';

/**
 * Microsoft Entra ID SSO service — SmartCHG v1 flow.
 *
 *   1. Frontend calls GET /auth/sso/authorize-url; backend returns a fully-
 *      formed Microsoft authorize URL (state stashed server-side in Redis,
 *      10-min TTL).
 *   2. Frontend does window.location.href = authorize_url.
 *   3. Microsoft redirects to /callback?code=...&state=... on THIS frontend.
 *   4. The /callback page (LoginCallback.tsx) POSTs whichever of
 *      {code, state, error, error_description} it received to
 *      /auth/sso/callback and stores the returned JWT + user.
 *
 * No local callback server is used.
 */

export type AuthorizeUrlResponse = {
    authorization_url: string;
    state: string;
};

class SSOService {
    async initiateLogin(): Promise<void> {
        try {
            logInfo('SSO', 'Requesting Microsoft authorize URL');
            const response = await api.get<AuthorizeUrlResponse>('/auth/sso/authorize-url');
            const url = response.data?.authorization_url;
            if (!url) {
                throw new Error('Backend did not return an authorize URL');
            }
            logInfo('SSO', 'Redirecting to Microsoft');
            window.location.href = url;
        } catch (error: unknown) {
            logError(
                'SSO',
                'Failed to initiate SSO login',
                error instanceof Error ? error : new Error('Unknown error')
            );
            throw error;
        }
    }
}

export const ssoService = new SSOService();
